"use client";

import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Chart.js modüllerini kaydetme
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const watermarkPlugin = {
  id: "watermark",
  beforeDraw: (chart) => {
    const ctx = chart.ctx;
    const { width, height } = chart.canvas;

    ctx.save();

    // Dinamik yazı boyutunu ayarlama (ekran genişliğine göre)
    // Mobil cihazlar için daha küçük bir minimum boyut belirleyelim
    const fontSize = Math.max(10, Math.min(28, width / 20)); // Minimum 12px, Maksimum 30px

    ctx.font = `bold ${fontSize}px Arial`; // Dinamik yazı boyutu
    ctx.fillStyle = "rgba(150, 150, 150, 0.6)"; // Filigran rengi ve şeffaflığı
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    // Pozisyonlama ve döndürme
    // Mobil cihazlarda alan daha küçük olabileceğinden, filigranı daha merkezi bir yere yerleştirelim
    const scaleFactor = window.devicePixelRatio || 1; // DPI çarpanını dikkate al
    ctx.translate(width / 2 / scaleFactor, height / 2 / scaleFactor);
    ctx.rotate(-Math.PI / 6);
    ctx.fillText("www.uscmarkets.com", 0, 0);
    ctx.restore();
  },
};

const DynamicPriceChart = ({ kod, data }) => {
  if (!data || data.length === 0) {
    return <p>Veri bulunamadı!</p>;
  }

  // Grafik verilerini JSON'dan ayıkla
  const labels = data.map((item) => item["Bilanço Dönemi"]); // X ekseni
  const gerceklesen = data.map((item) => item["Gerçekleşen"] || null);
  const tahminEdilen = data.map((item) => item["Tahmin Edilen"] || null);

  // Chart.js veri yapısı
  const chartData = {
    labels,
    datasets: [
      {
        label: "Gerçekleşen Fiyatlar",
        data: gerceklesen,
        borderColor: "orange",
        backgroundColor: "rgba(255, 165, 0, 0.2)",
        borderWidth: 2,
        pointStyle: "cross",
        pointRadius: 6,
        spanGaps: true,
      },
      {
        label: "Tahmin Edilen Fiyatlar",
        data: tahminEdilen,
        borderColor: "green",
        backgroundColor: "rgba(0, 128, 0, 0.2)",
        borderWidth: 2,
        pointStyle: "circle",
        pointRadius: 4,
      },
    ],
  };

  // Chart.js ayarları
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: `${kod} - Yapay Zeka ile Bilanço Hedef Fiyatı`,
        font: { size: 16 },
      },
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Bilanço Dönemi",
        },
      },
      y: {
        title: {
          display: true,
          text: "Ortalama Fiyat",
        },
        beginAtZero: false,
      },
    },
  };

  return (
    <div
      style={{
        width: "90%",
        maxWidth: "800px",
        height: "400px",
        margin: "20px auto",
      }}
    >
      <Line
        data={chartData}
        options={options}
        plugins={[watermarkPlugin]} // Filigran eklentisini burada kullan
      />
    </div>
  );
};

export default DynamicPriceChart;
